"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.classes = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _kinit = require("skmeans/kinit");
var _floor = _interopRequireDefault(require("lodash/floor"));
var _toNumber2 = _interopRequireDefault(require("lodash/toNumber"));
var _isNaN2 = _interopRequireDefault(require("lodash/isNaN"));
var _LearningView = _interopRequireDefault(require("./LearningView"));
var _Chart = _interopRequireDefault(require("./Chart"));
var _DataTable = _interopRequireDefault(require("../DataTable"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); } // import { kmpp } from 'skmeans/dist/node/kinit';
var GRAPH_COLOR = ['#4f80ff', '#f16670', '#6e5ae6', '#00b6b1', '#9fbaff', '#fcad93', '#c5b4ff', '#b3c3cd', '#2d51ac', '#a23941', '#423496', '#2a7d7f'];
var classes = exports.classes = ['ai_learning_train', 'ai_learning_cluster', 'cluster_attr_1', 'cluster_attr_2', 'cluster_attr_3', 'cluster_attr_4', 'cluster_attr_5', 'cluster_attr_6', 'ai_learning_train_chart'];
var _attrLength = /*#__PURE__*/new WeakMap();
var _trainParam = /*#__PURE__*/new WeakMap();
var _result = /*#__PURE__*/new WeakMap();
var _table = /*#__PURE__*/new WeakMap();
var _trainCallback = /*#__PURE__*/new WeakMap();
var _chart = /*#__PURE__*/new WeakMap();
var _isTrained = /*#__PURE__*/new WeakMap();
var _chartEnable = /*#__PURE__*/new WeakMap();
var _view = /*#__PURE__*/new WeakMap();
var _predictResult = /*#__PURE__*/new WeakMap();
var _fields = /*#__PURE__*/new WeakMap();
var _name = /*#__PURE__*/new WeakMap();
var Cluster = /*#__PURE__*/function () {
  function Cluster() {
    var _this = this;
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, Cluster);
    _classPrivateFieldInitSpec(this, _attrLength, 0);
    _classPrivateFieldInitSpec(this, _trainParam, null);
    _classPrivateFieldInitSpec(this, _result, {});
    _classPrivateFieldInitSpec(this, _table, {});
    _classPrivateFieldInitSpec(this, _trainCallback, void 0);
    _classPrivateFieldInitSpec(this, _chart, null);
    _classPrivateFieldInitSpec(this, _isTrained, false);
    _classPrivateFieldInitSpec(this, _chartEnable, false);
    _classPrivateFieldInitSpec(this, _view, null);
    _classPrivateFieldInitSpec(this, _predictResult, null);
    _classPrivateFieldInitSpec(this, _fields, []);
    _classPrivateFieldInitSpec(this, _name, '');
    _classPrivateFieldSet(_view, this, new _LearningView["default"]({
      name: params.name || '',
      status: 0
    }));
    // 정지시 data 초기화.
    Entry.addEventListener('stop', function () {
      _this.init(_objectSpread({}, params));
    });
    this.init(_objectSpread({}, params));
  }
  return (0, _createClass2["default"])(Cluster, [{
    key: "init",
    value: function init(_ref) {
      var _this2 = this,
        _table$select,
        _table$select2;
      var name = _ref.name,
        result = _ref.result,
        table = _ref.table,
        trainParam = _ref.trainParam;
      _classPrivateFieldSet(_name, this, name);
      _classPrivateFieldSet(_trainParam, this, trainParam);
      _classPrivateFieldSet(_result, this, result);
      _classPrivateFieldSet(_table, this, table);
      _classPrivateFieldSet(_trainCallback, this, function (value) {
        _classPrivateFieldGet(_view, _this2).setValue(value);
      });
      _classPrivateFieldSet(_isTrained, this, true);
      _classPrivateFieldSet(_attrLength, this, (table === null || table === void 0 || (_table$select = table.select) === null || _table$select === void 0 || (_table$select = _table$select[0]) === null || _table$select === void 0 ? void 0 : _table$select.length) || 0);
      if (_classPrivateFieldGet(_attrLength, this) === 2) {
        _classPrivateFieldSet(_chartEnable, this, true);
      }
      _classPrivateFieldSet(_fields, this, table === null || table === void 0 || (_table$select2 = table.select) === null || _table$select2 === void 0 || (_table$select2 = _table$select2[0]) === null || _table$select2 === void 0 ? void 0 : _table$select2.map(function (index) {
        return table === null || table === void 0 ? void 0 : table.fields[index];
      }));
    }
  }, {
    key: "setTable",
    value: function setTable() {
      var _classPrivateFieldGet2, _tableSource$fields;
      var tableSource = _DataTable["default"].getSource(_classPrivateFieldGet(_table, this).id);
      if (((_classPrivateFieldGet2 = _classPrivateFieldGet(_table, this)) === null || _classPrivateFieldGet2 === void 0 || (_classPrivateFieldGet2 = _classPrivateFieldGet2.fieldsInfo) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.length) !== (tableSource === null || tableSource === void 0 || (_tableSource$fields = tableSource.fields) === null || _tableSource$fields === void 0 ? void 0 : _tableSource$fields.length)) {
        Entry.toast.alert(Lang.Msgs.warn, Lang.AiLearning.train_param_error);
        throw Error(Lang.AiLearning.train_param_error);
      }
      _classPrivateFieldGet(_table, this).data = tableSource.rows;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _classPrivateFieldGet(_view, this).destroy();
      if (_classPrivateFieldGet(_chart, this)) {
        _classPrivateFieldGet(_chart, this).destroy();
        _classPrivateFieldSet(_chart, this, null);
      }
    }
  }, {
    key: "setVisible",
    value: function setVisible(visible) {
      _classPrivateFieldGet(_view, this).setVisible(visible);
    }
  }, {
    key: "unbanBlocks",
    value: function unbanBlocks(blockMenu) {
      blockMenu.unbanClass("ai_learning_train");
      blockMenu.unbanClass("ai_learning_cluster");
      blockMenu.unbanClass("cluster_attr_".concat(_classPrivateFieldGet(_attrLength, this)));
      if (_classPrivateFieldGet(_chartEnable, this)) {
        blockMenu.unbanClass('ai_learning_train_chart');
      }
    }
  }, {
    key: "isTrained",
    value: function isTrained() {
      return _classPrivateFieldGet(_isTrained, this);
    }
  }, {
    key: "openChart",
    value: function openChart() {
      if (!_classPrivateFieldGet(_chartEnable, this)) {
        return;
      }
      if (!_classPrivateFieldGet(_chart, this)) {
        var _classPrivateFieldGet3 = _classPrivateFieldGet(_trainParam, this),
          k = _classPrivateFieldGet3.k;
        _classPrivateFieldSet(_chart, this, new _Chart["default"]({
          source: this.chartData,
          title: Lang.AiLearning.chart_title,
          description: "\n                    <em>".concat(Lang.AiLearning.cluster_number, "</em>   ").concat(k, "\n                    ").concat(_classPrivateFieldGet(_fields, this).map(function (field, index) {
            return "<em>".concat(Lang.AiLearning.model_attr_str, " ").concat(index + 1, "</em>").concat(field);
          }), "\n                ")
        }));
      } else {
        _classPrivateFieldGet(_chart, this).show();
      }
    }
  }, {
    key: "closeChart",
    value: function closeChart() {
      var _classPrivateFieldGet4;
      (_classPrivateFieldGet4 = _classPrivateFieldGet(_chart, this)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.hide();
    }
  }, {
    key: "setTrainOption",
    value: function setTrainOption(type, value) {
      _classPrivateFieldSet(_trainParam, this, _objectSpread(_objectSpread({}, _classPrivateFieldGet(_trainParam, this)), {}, (0, _defineProperty2["default"])({}, type, value)));
    }
  }, {
    key: "getTrainOption",
    value: function getTrainOption() {
      return _classPrivateFieldGet(_trainParam, this);
    }
  }, {
    key: "getTrainResult",
    value: function getTrainResult() {
      return _classPrivateFieldGet(_result, this);
    }
  }, {
    key: "getResult",
    value: function getResult() {
      return _classPrivateFieldGet(_predictResult, this);
    }
  }, {
    key: "train",
    value: function train() {
      var _classPrivateFieldGet7;
      this.setTable();
      _classPrivateFieldGet(_trainCallback, this).call(this, 1);
      _classPrivateFieldSet(_isTrained, this, false);
      var _classPrivateFieldGet5 = _classPrivateFieldGet(_table, this),
        data = _classPrivateFieldGet5.data,
        select = _classPrivateFieldGet5.select;
      var filtered = data.filter(function (row) {
        return !select.flat().some(function (selected) {
          return (0, _isNaN2["default"])((0, _toNumber2["default"])(row[selected]));
        });
      });
      var _select = (0, _slicedToArray2["default"])(select, 1),
        attr = _select[0];
      var _kmeans = kmeans(filtered.map(function (row) {
          return attr.map(function (i) {
            return parseFloat(row[i]) || 0;
          });
        }), _classPrivateFieldGet(_trainParam, this)),
        centroids = _kmeans.centroids,
        indexes = _kmeans.indexes;
      _classPrivateFieldSet(_result, this, {
        graphData: convertGraphData(filtered, centroids, indexes, attr),
        centroids: centroids
      });
      _classPrivateFieldSet(_isTrained, this, true);
      var _classPrivateFieldGet6 = _classPrivateFieldGet(_trainParam, this),
        k = _classPrivateFieldGet6.k;
      (_classPrivateFieldGet7 = _classPrivateFieldGet(_chart, this)) === null || _classPrivateFieldGet7 === void 0 || _classPrivateFieldGet7.load({
        source: this.chartData,
        description: "\n                    <em>".concat(Lang.AiLearning.cluster_number, "</em>   ").concat(k, "\n                    ").concat(_classPrivateFieldGet(_fields, this).map(function (field, index) {
          return "<em>".concat(Lang.AiLearning.model_attr_str, " ").concat(index + 1, "</em>").concat(field);
        }), "\n                ")
      });
      _classPrivateFieldGet(_trainCallback, this).call(this, 100);
    }
  }, {
    key: "predict",
    value: function predict() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!this.isTrained) {
        return;
      }
      var _classPrivateFieldGet8 = _classPrivateFieldGet(_trainParam, this),
        k = _classPrivateFieldGet8.k;
      var _classPrivateFieldGet9 = _classPrivateFieldGet(_result, this),
        centroids = _classPrivateFieldGet9.centroids;
      _classPrivateFieldSet(_predictResult, this, predictCluster(arr, k, centroids) + 1);
      return _classPrivateFieldGet(_predictResult, this);
    }
  }, {
    key: "findColor",
    value: function findColor(id, a, b) {
      var _classPrivateFieldGet0 = _classPrivateFieldGet(_result, this),
        centroids = _classPrivateFieldGet0.centroids,
        graphData = _classPrivateFieldGet0.graphData;
      if (id === 'y') {
        var _ref2 = (graphData === null || graphData === void 0 ? void 0 : graphData.find(function (_ref3) {
            var x = _ref3.x,
              y = _ref3.y;
            return String(x) === String(a) && String(y) === String(b);
          })) || {},
          _ref2$type = _ref2.type,
          type = _ref2$type === void 0 ? 0 : _ref2$type;
        return GRAPH_COLOR[type];
      } else if (id === 'centroid' && b) {
        var _type = (centroids === null || centroids === void 0 ? void 0 : centroids.findIndex(function (_ref4) {
          var _ref5 = (0, _slicedToArray2["default"])(_ref4, 1),
            x = _ref5[0];
          return String(x) === String(a);
        })) || 0;
        return GRAPH_COLOR[_type];
      }
      return undefined;
    }
  }, {
    key: "chartData",
    get: function get() {
      var _this3 = this;
      return {
        data: {
          type: 'scatter',
          json: _classPrivateFieldGet(_result, this).graphData,
          keys: {
            value: ['y', 'centroid'],
            x: 'x'
          },
          color: function color(_color, d) {
            return _this3.findColor(d.id, d.x, d.value) || _color;
          },
          labels: false
        },
        options: {
          point: {
            pattern: ['circle',
            // eslint-disable-next-line max-len
            "<g><circle cx='10' cy='10' r='10'></circle><rect x='5' y='5' width='10' height='10' style='fill:#fff'></rect></g>"]
          },
          legend: {
            show: false
          },
          tooltip: {
            contents: function contents(data) {
              var _data = (0, _slicedToArray2["default"])(data, 1),
                _data$ = _data[0],
                x = _data$.x,
                value = _data$.value,
                id = _data$.id;
              if (id === 'centroid' && value) {
                var _classPrivateFieldGet1 = _classPrivateFieldGet(_result, _this3),
                  centroids = _classPrivateFieldGet1.centroids;
                var type = centroids === null || centroids === void 0 ? void 0 : centroids.findIndex(function (_ref6) {
                  var _ref7 = (0, _slicedToArray2["default"])(_ref6, 2),
                    a = _ref7[0],
                    b = _ref7[1];
                  return x === a && value === b;
                });
                return "\n                                <div class=\"chart_handle_wrapper\">\n                                    ".concat(Lang.AiLearning.centriod, " ").concat(type + 1, "| ").concat(_classPrivateFieldGet(_fields, _this3)[0], ": ").concat(x, ", ").concat(_classPrivateFieldGet(_fields, _this3)[1], ": ").concat(value, "\n                                <div>\n                            ");
              }
              return "\n                            <div class=\"chart_handle_wrapper\">\n                                ".concat(_classPrivateFieldGet(_fields, _this3)[0], ": ").concat(x, ", ").concat(_classPrivateFieldGet(_fields, _this3)[1], ": ").concat(value, "\n                            <div>\n                        ");
            }
          },
          axis: {
            x: {
              tick: {
                fit: false,
                count: 5
              }
            }
          },
          grid: {
            x: {
              show: true
            },
            y: {
              show: true
            }
          }
        }
      };
    }
  }]);
}();
var _default = exports["default"] = Cluster;
function convertGraphData(data, centroids, indexes, attr) {
  return data.map(function (cur, index) {
    return cur.reduce(function (acc, cur, idx) {
      if (idx === attr[0]) {
        acc.x = cur;
      } else if (idx === attr[1]) {
        acc.y = cur;
      }
      return acc;
    }, {
      index: index,
      type: indexes[index]
    });
  }).concat(centroids.map(function (_ref8, type) {
    var _ref9 = (0, _slicedToArray2["default"])(_ref8, 2),
      _ref9$ = _ref9[0],
      x = _ref9$ === void 0 ? 0 : _ref9$,
      _ref9$2 = _ref9[1],
      centroid = _ref9$2 === void 0 ? 0 : _ref9$2;
    return {
      x: x,
      centroid: centroid,
      type: type
    };
  }));
}
function eudist(a, b) {
  var sum = 0;
  for (var i = 0; i < a.length; i++) {
    var d = (a[i] || 0) - (b[i] || 0);
    sum += d * d;
  }
  return sum;
}
function predictCluster(arr, k, centroids) {
  var min = Infinity;
  var closestCentroidIndex = 0;
  for (var i = 0; i < k; i++) {
    var dist = eudist(arr, centroids[i]);
    if (dist < min) {
      min = dist;
      closestCentroidIndex = i;
    }
  }
  return closestCentroidIndex;
}
function kmeans(inputs, trainParam) {
  var dim = inputs[0].length;
  var centroids = [];
  if (!trainParam.initialCentroids) {
    var _idxs = {};
    while (centroids.length < trainParam.k) {
      var idx = Math.floor(Math.random() * inputs.length);
      if (!_idxs[idx]) {
        _idxs[idx] = true;
        centroids.push(inputs[idx].slice());
      }
    }
  } else if (trainParam.initialCentroids === 'random') {
    var maxs = new Array(dim).fill(-Infinity);
    var mins = new Array(dim).fill(Infinity);
    for (var i = 0; i < dim; i++) {
      for (var j = 0; j < inputs.length; j++) {
        if (inputs[j][i] < mins[i]) {
          mins[i] = inputs[j][i];
        }
        if (inputs[j][i] > maxs[i]) {
          maxs[i] = inputs[j][i];
        }
      }
    }
    for (var _i = 0; _i < trainParam.k; _i++) {
      var temp = [];
      for (var _j = 0; _j < dim; _j++) {
        temp.push(Math.random() * (maxs[_j] - mins[_j]) + mins[_j]);
      }
      centroids.push(temp);
    }
  } else if (trainParam.initialCentroids === 'kmpp') {
    centroids = (0, _kinit.kmpp)(inputs.map(function (e) {
      return e.slice();
    }), trainParam.k);
  } else {
    centroids = trainParam.initialCentroids;
  }
  var indexes = new Array(inputs.length).fill(0);
  var iter = 0;
  var maxIter = trainParam.maxIter || 10000;
  var conv = false;
  var _loop = function _loop() {
    // copy old centroids
    var oldCentroids = centroids.map(function (e) {
      return e.slice();
    });

    // set inputs idx (closest centroid index)
    for (var _i2 = 0; _i2 < inputs.length; _i2++) {
      indexes[_i2] = predictCluster(inputs[_i2], trainParam.k, centroids);
    }

    // move centroid to avg inputs
    var sums = Array.from(new Array(trainParam.k), function () {
      return new Array(dim).fill(0);
    });
    var counts = new Array(trainParam.k).fill(0);
    for (var _i3 = 0; _i3 < inputs.length; _i3++) {
      counts[indexes[_i3]]++;
      for (var _j2 = 0; _j2 < dim; _j2++) {
        sums[indexes[_i3]][_j2] += inputs[_i3][_j2];
      }
    }
    for (var _i4 = 0; _i4 < trainParam.k; _i4++) {
      for (var _j3 = 0; _j3 < dim; _j3++) {
        centroids[_i4][_j3] = (0, _floor["default"])(sums[_i4][_j3] / counts[_i4], 2);
      }
    }

    // check conv
    var centroidsUpdateDistance = 0;
    centroids.forEach(function (e, i) {
      centroidsUpdateDistance += eudist(e, oldCentroids[i]);
    });
    if (centroidsUpdateDistance === 0) {
      conv = true;
    }
    if (trainParam.onIterEnd) {
      trainParam.onIterEnd(oldCentroids.map(function (e) {
        return e.slice();
      }), centroids.map(function (e) {
        return e.slice();
      }));
    }
    iter++;
  };
  while (!conv && iter < maxIter) {
    _loop();
  }
  return {
    iter: iter,
    indexes: indexes,
    centroids: centroids
  };
}